import JsBarcode from "jsbarcode";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { Field, reduxForm } from "redux-form";
import { Button, Input } from "expano-components";
import { Modal } from "components";
import { StickerEanCode } from "sticker_templates";
import { ReactComponent as Sticker } from "icons/sticker.svg";

const InputField = (props) => <Input {...props} />;

const validate = (values) => {
  const errors = {};
  if (!values.quantity) {
    errors.validate = "Pole wymagane!";
  } else if (isNaN(Number(values.quantity))) {
    errors.quantity = "Musi być liczbą!";
  } else if (Number(values.quantity) < 1) {
    errors.quantity = "Wartość musi byc wieksza od 0!";
  }
  return errors;
};

const EanCodeStickerModal = ({ data, invalid, handleSubmit, handleClose }) => {
  const submit = async ({ quantity }) => {
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, data.ean, {
      format: "EAN13",
      width: 2,
      height: 50,
      displayValue: true,
    });

    const barcode = canvas.toDataURL("image/png");
    const blob = await pdf(
      <StickerEanCode
        data={[
          {
            sku: data?.sku,
            ean: data?.ean,
            quantity: Number(quantity)?.toFixed(0),
            barcode,
          },
        ]}
      />,
    ).toBlob();
    saveAs(blob, `${data?.sku}-qr.pdf`);
    handleClose();
  };
  return (
    <Modal
      header={{ title: "Naklejki Ean", icon: <Sticker /> }}
      footer={
        <>
          <Button type="cancel" text="Anuluj" onClick={handleClose} />
          <Button
            type="save"
            text="Pobierz"
            disabled={invalid}
            onClick={handleSubmit(submit)}
          />
        </>
      }
      handleClose={handleClose}
    >
      <form noValidate>
        <div className="row">
          <div className="box-12">
            <Field
              label="Ilość"
              name="quantity"
              type="number"
              component={InputField}
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default reduxForm({
  form: "ean-code-sticker",
  validate,
  enableReinitialize: true,
})(EanCodeStickerModal);
